import {
  OrganisationPurchaseRequestSummaryTable,
  OrganisationPurchaseRequestValuationCard,
} from "@fero/components";
import type { PurchaseRequestConfirmationData } from "@fero/pages";
import { Fade, Grid, Skeleton } from "@mui/material";
import { BaseWizardCard } from "components/library/widgets/wizard-card/base-wizard-card";
import type React from "react";
import { isLoaded, type LoadingValue } from "utils/utility-types";

interface OrderSummaryPreviewCardProps {
  purchaseRequestData: LoadingValue<PurchaseRequestConfirmationData>;
  advanceCashUponDelivery: boolean;
  setAdvanceCashUponDelivery: (advanceUponDelivery: boolean) => void;
}

export const OrderSummaryPreviewCard: React.FC<
  OrderSummaryPreviewCardProps
> = ({
  purchaseRequestData,
  advanceCashUponDelivery,
  setAdvanceCashUponDelivery,
}) => {
  const isDataLoaded = isLoaded(purchaseRequestData);

  return (
    <BaseWizardCard
      title={"Order Summary"}
      subtitle={"Please see a summary of the products included in this order."}
      inputElement={
        <Grid container item xs={12} style={{ minHeight: 500 }}>
          {!isDataLoaded && (
            <Fade in={!isDataLoaded} timeout={500} unmountOnExit>
              <Skeleton
                variant="rectangular"
                width="100%"
                height="100%"
                animation="wave"
              />
            </Fade>
          )}

          {isDataLoaded && (
            <Fade in={isDataLoaded} timeout={500}>
              <Grid container item xs={12}>
                <Grid item xs={12}>
                  <OrganisationPurchaseRequestSummaryTable
                    {...purchaseRequestData.value}
                    isUnfulfilledEndState={false}
                    isPreview={true}
                    products={purchaseRequestData.value.summary.lineItems}
                  />
                </Grid>
                <Grid item xs={12}>
                  <OrganisationPurchaseRequestValuationCard
                    {...purchaseRequestData.value}
                    {...purchaseRequestData.value.summary}
                    isPreview={true}
                    isEstimate={true}
                    isDelivered={false}
                    additionalMonthlyFees={
                      purchaseRequestData.value.additionalMonthlyFeeAmount
                    }
                    netReceivable={
                      purchaseRequestData.value.netReceivableAmount
                    }
                    advanceCashUponDelivery={advanceCashUponDelivery}
                    setAdvanceCashUponDelivery={setAdvanceCashUponDelivery}
                    cashAmountToAdvanceUponDelivery={
                      purchaseRequestData.value.summary.discountedReceivable
                        ?.amountAdvancedUponDelivery ?? null
                    }
                    advanceUponDeliveryPaymentDate={null}
                    orgNetReceivablePaymentDate={null}
                  />
                </Grid>
              </Grid>
            </Fade>
          )}
        </Grid>
      }
    />
  );
};
